import React from 'react';
import { Modal, ModalBody, ModalFooter } from '@carbon/react';

export const NoFreeLicences = ({hideModal}) => {

  return (
    <Modal
      open={true}
      danger={false}
      size="sm"
      primaryButtonText="OK"
      secondaryButtonText="Abbrechen"
      modalHeading="Du hast keine freien Lizenzen"
      onRequestClose={hideModal}
      onRequestSubmit={hideModal}>
      <ModalBody>
        <p>Um Micast-Systeme Einrichten zu benötigst du mehr Lizenzen.</p>
        <br />
        <p>
          Du kannst dein Abo und deine Lizenzen in deinem Profil überprüfen.
        </p>
      </ModalBody>
      <ModalFooter></ModalFooter>
    </Modal>
  );
};
